/* eslint-disable no-nested-ternary */
import { classnames } from '@aibees/shared/utils';
import { Button, Divider } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanComparePlansProps as Props } from './types';

export const PlanComparePlans = memo(({ className }: Props) => {
  const { isMostPopular } = usePlanCardContext();

  return (
    <Styled.Wrapper
      className={classnames('PlanComparePlans', className)}
      sx={SX.root}
    >
      <Divider flexItem />
      <Button
        rel="comparison"
        size="small"
        variant={isMostPopular ? 'contained' : 'text'}
        color={isMostPopular ? 'primary' : 'default'}
      >
        Compare Plans
      </Button>
    </Styled.Wrapper>
  );
});

PlanComparePlans.displayName = 'PlanComparePlans';
